unsafeHandlePartialRefetch